import React from 'react';
import './Skills.css';

const Skills = ({ competencies = [], tools = [], languages = [] }) => {
  const compIcon = (name) => {
    const map = {
      'Business Development': '/icons/competencies/business-development.png',
      'Analytical Thinking': '/icons/competencies/analytical-thinking.png',
      'Problem Solving': '/icons/competencies/problem-solving.png',
      'Data Analysis': '/icons/competencies/data-analysis.png',
      'Project Management': '/icons/competencies/project-management.png',
      'Strategic Planning': '/icons/competencies/strategic-planning.png'
    };
    if (map[name]) return map[name];
    const pool = Object.values(map);
    if (pool.length === 0) return null;
    const idx = Math.floor(Math.random() * pool.length);
    return pool[idx];
  };
  const toolIcon = (name) => {
    const map = {
      'Python': '/icons/tools/python-svgrepo-com.svg',
      'Excel': '/icons/tools/excel-svgrepo-com.svg',
      'SAS EG': '/icons/tools/sas-logo-horiz.svg',
      'Oracle SQL': '/icons/tools/oracle-sql.svg',
      'SQL': '/icons/tools/sql.svg',
      'Power BI': '/icons/tools/New_Power_BI_Logo.svg',
      'Flutter': '/icons/tools/flutter-svgrepo-com.svg',
      'AWS': '/icons/tools/aws.png',
      'Azure': '/icons/tools/azure.svg',
      'Google Cloud': '/icons/tools/google-cloud.png',
      'Git': '/icons/tools/git.svg',
      'Docker': '/icons/tools/docker.svg',
      'PostgreSQL': '/icons/tools/postgresql.svg',
      'MySQL': '/icons/tools/mysql.svg',
      'MongoDB': '/icons/tools/mongodb.svg',
      'React': '/icons/tools/react.png',
      'Node.js': '/icons/tools/nodejs.png',
      'JavaScript': '/icons/tools/javascript.png',
      'Java': '/icons/tools/java.svg',
      'R': '/icons/tools/r.png',
      'Tableau': '/icons/tools/tableau.svg',
      'C++': '/icons/tools/cpp.png'
    };
    return map[name] || null;
  };
  const flagFor = (name) => {
    const map = {
      'Turkish': '🇹🇷',
      'English': '🇬🇧',
      'German': '🇩🇪',
      'French': '🇫🇷',
      'Spanish': '🇪🇸'
    };
    return map[name] || '🌐';
  };
  const codeToEmoji = (code) => {
    if (!code || code.length !== 2) return null;
    const cc = code.toUpperCase();
    const base = 127397;
    return String.fromCodePoint(cc.charCodeAt(0) + base) + String.fromCodePoint(cc.charCodeAt(1) + base);
  };
  const nameToCode = (name) => {
    const map = {
      'Turkish': 'tr',
      'English': 'gb',
      'German': 'de',
      'French': 'fr',
      'Spanish': 'es'
    };
    return map[name] || null;
  };

  return (
    <section id="skills" className="skills">
      <div className="container">

        <div className="skills-content">
          <div className="skills-section">
            <h3 className="skills-section-title">COMPETENCIES</h3>
            <div className="competencies-grid">
              {competencies.map((competency, index) => (
                <div key={index} className="competency-card">
                  <div className="competency-content">
                    <div className="competency-icon">
                      {compIcon(competency.name) ? (
                        <img src={compIcon(competency.name)} alt={competency.name} className="competency-icon" />
                      ) : null}
                    </div>
                    <span className="competency-name">{competency.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skills-section">
            <h3 className="skills-section-title">TOOLS & SOFTWARE</h3>
            <div className="tools-grid">
              {tools.map((tool, index) => (
                <div key={index} className="tool-card">
                  <div className="tool-icon">
                    {toolIcon(tool.name) ? (
                      <img src={toolIcon(tool.name)} alt={tool.name} className="tool-icon" />
                    ) : null}
                  </div>
                  <div className="tool-info">
                    <h4 className="tool-name">{tool.name}</h4>
                    <p className="tool-category">{tool.usage_purpose || tool.category}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="skills-section">
            <h3 className="skills-section-title">LANGUAGES</h3>
            <div className="languages-grid">
              {languages.map((language, index) => (
                <div key={index} className="language-card">
                  <div className="language-flag">
                    {(() => {
                      const code = (language.flag && language.flag.length === 2 ? language.flag.toLowerCase() : nameToCode(language.name)) || null;
                      if (code) {
                        return <span className={`fi fi-${code}`} style={{width: 28, height: 20}}></span>;
                      }
                      return codeToEmoji(language.flag) || flagFor(language.name);
                    })()}
                  </div>
                  <div className="language-info">
                    <div className="language-name">{language.name}</div>
                    <div className="language-level">{language.level}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;

